module.exports = __webpack_public_path__ + "static/media/progress.1b111eb6.svg";